import React from 'react';
import { createBrowserRouter } from 'react-router';
import { NotFoundState } from '@oniratec/onira-react-ui';

import { AuthLayout } from './layouts/AuthLayout';
import { DashboardLayout } from './layouts/DashboardLayout';
import { RootLayout } from './layouts/RootLayout';
import { HelpLayout } from '@/modules/help/components/HelpLayout';
import { authChildren } from '@/routes/childrens/auth';
import { dashboardChildren } from '@/routes/childrens/dashboard';
import { helpChildren } from '@/routes/childrens/help';
import { publicChildren } from '@/routes/childrens/public';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: (
      <NotFoundState
        title="No se pudo mostrar la página"
        actionLabel="Reintentar"
        onAction={() => window.location.reload()}
      />
    ),
    children: [
      {
        path: 'auth',
        element: <AuthLayout />,
        children: authChildren,
      },
      {
        // Public help area. Declared before the panel users/:id route so
        // /users/doc always opens the help pages, never a user detail page.
        path: 'users/doc',
        element: <HelpLayout />,
        children: helpChildren,
      },
      {
        element: <DashboardLayout />,
        children: dashboardChildren,
      },
      {
        path: 'p',
        children: publicChildren,
      },
      {
        path: '*',
        element: (
          <NotFoundState
            title="Página no encontrada"
            actionLabel="Volver al inicio"
            onAction={() => window.location.assign('/dashboard')}
          />
        ),
      },
    ],
  },
]);
